import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { queryComboBoxList, showRelBusinessCard, activityBusinessCard } from '@/api/marketing/marketingManage'
import type { BusinessCardListItem } from '@/typings/api/marketingManage'


const __default__ = { name: 'CardLinkModal' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<{ activityQrcodeId: string; activityName: string; businessCardIdList: string[] }>({
  activityName: '',
  activityQrcodeId: '',
  businessCardIdList: []
})
const formRules = reactive({
  select: [{ required: false, message: '请选择' }]
})
const emit = __emit

const rowsProps = ref<BusinessCardListItem>()
const cardList = ref<BusinessCardListItem[]>([])
const getCardList = () => {
  queryComboBoxList().then((res) => {
    cardList.value = res.data.map((item: any) => ({
      label: `${item.followerName}(${item.follower})`,
      value: item.id
    }))
  })
}
const getRelCardList = (activityQrcodeId: string) => {
  showRelBusinessCard({ activityQrcodeId }).then((res) => {
    dataForm.businessCardIdList = res.data.map((item: any) => item.id) || []
  })
}
const init = (rows?: BusinessCardListItem) => {
  getCardList()
  if (rows?.id) getRelCardList(rows.id)
  rowsProps.value = rows
  if (rows) {
    dataForm.activityQrcodeId = rows.id
    dataForm.activityName = rows.activityName
  }
  visible.value = true
}

const filterOption = (input: string, option: { label: string; value: string }) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const handleOk = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    const params = {
      activityQrcodeId: dataForm.activityQrcodeId,
      businessCardIdList: dataForm.businessCardIdList
    }
    await activityBusinessCard(params)
    DcMessage.success('操作成功！')
    emit('fetch')
    handleCancel()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
const handleCancel = () => {
  formRef.value?.resetFields()
  setTimeout(() => (visible.value = false), 20)
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    width: 600,
    title: "关联名片",
    confirmLoading: loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        "wrapper-col": { span: 24 },
        ref_key: "formRef",
        ref: formRef,
        model: dataForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "活动名称",
            name: "activityName",
            rules: [{ required: true }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.activityName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.activityName) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "销售名片",
            name: "businessCardIdList",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.businessCardIdList,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.businessCardIdList) = $event)),
                options: cardList.value,
                mode: "multiple",
                "show-search": "",
                "filter-option": filterOption,
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})